<nz-page-header class="large p-l-8 p-r-0">
  <nz-page-header-title>
    {{ "inbox.title" | translate }}
  </nz-page-header-title>
</nz-page-header>

<mh-messages-inbox (conversationClick)="onConversationClick($event)"></mh-messages-inbox>
